import SettingsBox from 'src/Elements/Data/SettingsBox'
import React, { useMemo } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { FieldArray, useFormikContext } from 'formik'
import { WallboxSettingsFormModel } from 'src/Libs/wallboxes'
import { Box, Stack, useMediaQuery, useTheme } from '@mui/material'
import { NumberField, TextField } from 'src/Libs/inputs/formik'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import { SETTING_RESTRICTED_TO_SERVER_TRANSLATION_KEY } from 'src/Libs/farm/constants'
import { UnitTypes } from 'src/Libs/types'

// TODO: export into types file
export type VariantTypes = 'voltage' | 'full'

interface Props {
  name: string
  variant: VariantTypes
  disabled?: boolean
}

const WeekDaysSettingList: React.VFC<Props> = ({ name, variant, disabled = false }) => {
  const { t } = useCustomTranslation()
  const theme = useTheme()
  const { values } = useFormikContext<WallboxSettingsFormModel>()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  const doDisplayAll = useMemo<boolean>(() => variant === 'full', [variant])
  const listRenderer = (): React.ReactNode => {
    return values?.weekdays?.map((item, index) => {
      const inputFields = (
        <OptionalTooltipWrapper titleKey={disabled ? SETTING_RESTRICTED_TO_SERVER_TRANSLATION_KEY : ''}>
          <Stack spacing={1} display={'flex'} justifyContent={'end'} direction={{ xs: 'column', md: 'row' }} minWidth={'100%'}>
            {doDisplayAll && (
              <Box>
                <TextField type="time" clearable={false} name={`${name}.${index}.daytime`} disabled={disabled} textAlign={'right'} />
              </Box>
            )}
            <Box>
              <NumberField name={`${name}.${index}.minEnergy`} min={0} fullWidth={downMd} suffix={UnitTypes.kiloWattHour} disabled={disabled} />
            </Box>
          </Stack>
        </OptionalTooltipWrapper>
      )
      return <SettingsBox key={index} title={t(`systemSettings.wallbox.settings.day${index}`)} suffix={inputFields} disabled={disabled} />
    })
  }

  return <FieldArray name="weekdays" render={listRenderer} />
}

export default WeekDaysSettingList
